import { render } from "./index.vue?vue&type=template&id=1a8aa7c9"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Dashboard/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a8aa7c9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a8aa7c9', __exports__)) {
    api.reload('1a8aa7c9', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1a8aa7c9", () => {
    api.rerender('1a8aa7c9', render)
  })

}


export default __exports__